// This file is generated via scripts/build-static-config.js
  // Do not modify directly as changes will be overwritten in CI

  export const CONFIGURATION = {
    country: 'za',
    brand: 'bk',
    env: 'prod',
    graphqlEnv: 'prod',
    graphqlGatewayEnv: '',
    sanityEnv: 'prod',
    platform: 'web',
    commitRef: '62c745c2f5217637b5b35f2e38641850411545c3',
    releaseTagRef: 'aaeab4e',
    releaseTimestamp: '1754488539',
    sanityDataset: '',
    sanityProjectId: 'czqk28jt',
    appFlowBuildId: '',
    clickTrackingDomain: 'link.kingsnews.whopper.co.za',
    urlScheme: '',
    adyen: {
      clientKey: '',
      environment: '',
      urlPrefix: '',
    },
    apiKeys: {
      amplitude: '336620b2123401799fc6bcd2e2839c01',
      branch: 'key_live_ikT756yReORzXyM1EpB2HmgmysiPiGgK',
      braze: 'd6d18137-385f-4481-bd5b-ec9bc6bdc9ab',
      brazeCluster: 'sdk.iad-06.braze.com',
      bringg: '',
      googleMaps: 'AIzaSyBX1ecrMxvPlpzY3yI-TUZdvkgmYqu_jKs',
      tomtom: '',
      launchDarkly: '64468732c15c7c1247d007f2',
      launchDarklyMobileKey: 'mob-aed58077-9e33-470f-966c-4c40ffadaea9',
      mParticle: 'us1-e44fc439b61fda408517d179d4d90a31',
      amplitudeCdpKey: '',
      amplitudeCdpRegion: '',
    },
    apple: {
      merchantId: 'merchant.com.bk.native.tillster.prod',
      migrationMerchantId: '',
      paymentsNetworks: [],
      prepaidMerchantId: '',
      migrationPrepaidMerchantId: '',
      socialLogin: {
        clientId: '',
        redirectURI: '',
      },
    },
    branch: {
      domains: ['bksouthafrica.test-app.link','bksouthafrica-alternate.test-app.link','bksouthafrica.app.link','bksouthafrica-alternate.app.link']
    },
    checkoutDotCom: {
      publicKey: '',
    },
    facebook: {
      socialLogin: {
        appId: '',
        redirectURI: '',
      },
    },
    aws: {
      gqlApiUrl: 'https://euc1-prod-bk.rbictg.com/graphql',
      gqlGatewayApiUrl: 'https://euc1-prod-bk-gateway.rbictg.com/graphql',
      region: 'eu-central-1',
      userPoolClientId: '62ev1gv53cp9bckrt5gdinrqmj',
      userPoolId: 'eu-central-1_dwCOsnxKY',
    },
    bringg: {
      region: '5',
    },
    datadog: {
      logs: {
        clientToken: 'pub5560d3ea0973282cab306c73833e35d8',
        dataCenter: 'datadoghq.eu',
      },
      rum: {
        applicationId: 'd2ad1579-fd2d-4500-a5d1-baa39289ebe4',
        clientToken: 'pub5560d3ea0973282cab306c73833e35d8',
        dataCenter: 'datadoghq.eu',
      },
    },
    firstData: {
      corporateStoreId: '123456',
    },
    forter: {
      siteId: '6ebc7d54b003',
    },
    google: {
      paymentsEnvironment: 'prod',
      paymentsGateway: '',
      marketPaymentsGatewayMerchantId: '',
      paymentsGatewayMerchantId: {
        ca: '',
        us: '',
        ch: '',
      },
      migrationPaymentsGateway: '',
      migrationPaymentsGatewayMerchantId: {
        ca: '',
        us: '',
        ch: '',
      },
      paymentsNetworks: ['VISA'],
      prepaidPaymentsGateway: '',
      prepaidPaymentsGatewayMerchantId: {
        ca: '',
        us: '',
        ch: '',
      },
      migrationPrepaidPaymentsGateway: '',
      migrationPrepaidPaymentsGatewayMerchantId: {
        ca: '',
        us: '',
        ch: '',
      },
      socialLogin: {
        clientId: '',
        redirectURI: '',
      },
    },
    googleAdManager: {
      campaignId: '',
    },
    googleTagManager: {
      containerId: 'GTM-W44WW5D',
    },
    oneTrust: {
      cookieCompliance: {
        consentCategoryBranch: 'C0004',
        consentCategoryBraze: 'C0002',
        consentCategoryMParticle: 'C0001',
        consentCategoryAmplitude: '',
        globalConsentState: 'Opt-Out',
        scriptUrl: '',
        scriptId: '',
      },
      deleteAccountUrl: '',
    },
    pypestream: {
      scriptUrl: '',
      appId: '',
    },
    restaurants: {
      displayEnv: 'prod',
      validMobileOrderingEnvs: ['alpha','beta','live'],
    },
    urls: {
      braze: '',
      webBaseUrl: '',
    },
    tokenEx: {
      publicKey: '',
    },
    vrPayment: {
      braintreeTokenizationKey: '',
    },
    orbital: {
      baseUrl: '',
      subscriberId: '',
      pieFormat: '',
      mode: '',
    },
    timeFormat: '',
    dateFormat: '',
    addressFormat: '',
    maxCartQuantity: '',
    appStoreDeeplink: '',
    iosDeepLink: 'https://apps.apple.com/us/app/burger-king-sa/id1407663966',
    androidDeepLink: 'https://play.google.com/store/apps/details?id=za.co.wigroup.burgerking',
    cookieBanners: {
      cookieBanner:'',
      scriptId: '',
      oneTrust: {
        cookieCompliance: {
          consentCategoryBranch: '',
          consentCategoryBraze: '',
          consentCategoryMParticle: '',
          consentCategoryAmplitude: '',
          consentCategoryDdRum: '',
          globalConsentState: '',
          scriptUrl: '',
          scriptId: '',
        },
      },
    }
  };